import React, { useEffect } from 'react';
import { Afp } from '../../../../app/models/Afp';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import ActiveControl from '../../../../components/ActiveControl';
import { TransferReason } from '../../../../app/models/TransferReason';

type Props = {
    transferReasonDataForm: TransferReason;
    setTransferReasonDataForm: (transferReason: TransferReason) => void;
    errorFields?: any;
};

const TransferReasonForm = ({
    transferReasonDataForm,
    setTransferReasonDataForm,
    errorFields
}: Props) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        setTransferReasonDataForm({ ...transferReasonDataForm, [name]: value });
    };

    return (
        <>
            <div className="mb-2 row needs-validation">
                <label className="col-md-3 col-form-label">Nombre</label>
                <div className="col-md-9">
                    <input
                        name="name"
                        id="name"
                        type="text"
                        className={`form-control ${fieldHasError('name')}`}
                        value={transferReasonDataForm.name}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('name')}
                        placeholder="Ingrese el nombre de banco"
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('name')}
                    </div>
                </div>
            </div>
            <div className="mb-2 row needs-validation">
                <label className="col-md-3 col-form-label">Requiere rendición</label>
                <div className="col-md-9 d-flex align-items-center">
                    <ActiveControl
                        status={transferReasonDataForm.is_reportable ?? true}
                        id={0}
                        callback={(value) =>
                            setTransferReasonDataForm({
                                ...transferReasonDataForm,
                                is_reportable: value
                            })
                        }
                    />
                    <span className="ms-3 font-size-11 text-muted">
                        Los montos de este motivo se muestran en liquidaciones internas al filtrar
                        por fondos por rendir.
                    </span>
                </div>
            </div>
        </>
    );
};

export default TransferReasonForm;
